import React from 'react';
import styled, { css } from 'styled-components';
/* import breakpoints from '../../../vars/breakpoints';
import gutters from '../../../vars/gutters'; */
import colors from '../../../vars/colors';

export const ProcessCard = styled.div`
    width: 75%;
    display: inline-block;
    padding: 35px 0;
    border-top: solid 8px ${colors['peacock-blue']};
    border-bottom: solid 8px ${colors['peacock-blue']};
    .eyebrow {
        font-family: 'OneDotExt', sans-serif;
        font-weight: bold;
        font-size: 15px;
        color: ${colors['peacock-blue']};
        text-transform: uppercase;
    }
    .emphasis {
        font-family: 'OneDotCd', sans-serif;
        font-size: 45px;
        font-weight: bold;
        font-style: italic;
        color: ${colors['lipstick']};
        margin: 10px 0;
        text-transform: uppercase;
    }
    .copy {
        font-family: 'OneDot';
        font-weight: 300;
        font-size: 16px;
        line-height: 1.44;
        text-align: center;
    }
`;

export const Title = styled.div`
    display: inline-block;
    font-family: 'OneDot';
    font-size: 25px;
    font-weight: bold;
    line-height: 1.4;
    letter-spacing: 3px;
    text-align: center;
    text-transform: uppercase;
    color: ${colors['peacock-blue']};
    border-bottom: solid 15px ${colors['white-two']};
    margin-bottom: 100px;
`;



// WEBPACK FOOTER //
// ./src/components/modules/ProcessCards/styled-components.js